import React, { useState, useRef } from "react";
import {
  ResetPasswordService,
  getMobileNumberByEmail,
} from "../services/LoginService";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import * as Yup from "yup";
import { StandardButton } from "./common/GlobalElements/StandardButton";
import { ErrorMessage } from "./common/GlobalElements/Typography";
import { tokens } from "../public/tokens.js";
import { StandardErrorMessage } from "../utils/commonFunction.js";
export default function ResetPasswordForm(props) {
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [sms, setSms] = useState(false);
  const [smsMsg, setSmsMsg] = useState("");
  const [email, setEmail] = useState("");

  const emailField = useRef();

  let history = useHistory();


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: email,
      sms: sms,
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      values.domain = window.location.hostname;
      values.email_template = "reset_password";
      ResetPasswordService(values)
        .then((res) => {
          if (res.data.status == 1) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: res.data.message,
              timer: 3000,
              onOpen: function () {
                Swal.showLoading();
              },
            }).then(function (result) {
              if (result.dismiss === "timer") {
                setLoading(false);
                history.push("/");
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Failed",
              text: res.data.message,
            });
            setLoading(false);
          }
        })
        .catch(function (err) {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: err.response.data.message,
          });
          setLoading(false);
          return false;
        });
    },
  });

  const handleSms = (e) => {
    if (e.target.checked) {
      if (emailField.current.value != "") {
        setSms(true);
        setChecked(true);
        setSmsMsg("");

        if (formik.errors.email) {
          setSmsMsg("Incorrect Email");
        } else {
          messageFunction();
        }
      } else {
        setSmsMsg("Can’t send SMS without email address entered");
      }
    } else {
      setSms(false);
      setChecked(false);
      setSmsMsg("");
    }
  };

  const messageFunction = () => {
    getMobileNumberByEmail({ email: emailField.current.value })
      .then((res) => {
        setSmsMsg(
          "Sms will be sent to default mobile number: " + res.data.mobile
        );
      })
      .catch((error) => {
        setSmsMsg("Email not found in database!");
      });
  };

  const handleEmail = (e) => {
    if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        e.target.value
      ) 
    ) {
      setSmsMsg("Incorrect Email");
    } else {
      setSmsMsg("");
    }

    setEmail(e.target.value);
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text" id="">
              <i className="fal fa-user"></i>
            </span>
          </div>
          <input
            type="email"
            className={
              "form-control" +
              (formik.errors.email && formik.touched.email ? " is-invalid" : "")
            }
            placeholder="Email"
            name="email"
            onChange={(e) => handleEmail(e)}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            ref={emailField}
          />

        </div>

        <StandardButton
          fontSize={tokens.typography.fontSize["xl-18px"]}
          padding="14px 23px"
          maxHeight="none"
          gap="10px"
          className="btn-submit-info"
          textTransform="uppercase"
          disabled={loading}
          title="Submit"
        >
          {loading ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-paper-plane"></i>} Submit 
        </StandardButton>
        <StandardErrorMessage formik={formik} name="email" />
      </form>
    </>
  );
}
